import { useRef } from "react";
import { constants } from "../utils";

function useDebouncedFunction(callback, delay = constants.DEBOUNCE_TIME) {
	const timeoutRef = useRef<NodeJS.Timeout | null>(null);

	const debouncedFunction = (...args) => {
		// Limpia el timeout anterior
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}

		// Establece un nuevo timeout
		timeoutRef.current = setTimeout(() => {
			callback(...args); // Llama a la función original con los argumentos
		}, delay);
	};

	return debouncedFunction; // Devuelve la función con debounce
}

export default useDebouncedFunction;
